import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Row, Col, Table } from 'reactstrap';
import { getRendicionFondosById } from '../../helpers/api_helper';
import { useSelector } from 'react-redux';

const ModalLeerRendicionFondos = ({ isOpen, toggle, selectedRendicion }) => {
    const [rendicionData, setRendicionData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const tenantId = useSelector((state) => state.Context.tenantId);

    useEffect(() => {
        if (isOpen && selectedRendicion) {
            const [tipfol, numfol] = selectedRendicion.split('-');
            fetchRendicionData(tipfol, numfol);
        }
    }, [isOpen, selectedRendicion, tenantId]);

    const fetchRendicionData = async (tipfol, numfol) => {
        setLoading(true);
        setError(null);
        try {
            const response = await getRendicionFondosById(tipfol, numfol, { tenantId });
            setRendicionData(response);
        } catch (err) {
            setError(`Error al cargar los datos: ${err.message}`);
        } finally {
            setLoading(false);
        }
    };

    const formatDate = (date) => {
        if (!date) return '';
        const _date = new Date(date);
        const year = _date.getFullYear();
        const month = String(_date.getMonth() + 1).padStart(2, '0');
        const day = String(_date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} size="lg">
            <ModalHeader toggle={toggle}>Detalles de Rendición de Fondos</ModalHeader>
            <ModalBody>
                {loading ? (
                    <div className="text-center">Cargando...</div>
                ) : error ? (
                    <div className="alert alert-danger">{error}</div>
                ) : rendicionData ? (
                    <>
                        <h6>Encabezado</h6>
                        <Row>
                            <Col md={6}>
                                <p><strong>Empresa:</strong> {rendicionData.encabezado.CLAEMP}</p>
                                <p><strong>Tipo Folio:</strong> {rendicionData.encabezado.TIPFOL}</p>
                                <p><strong>N° Folio:</strong> {rendicionData.encabezado.NUMFOL}</p>
                                <p><strong>Fecha Movimiento:</strong> {formatDate(rendicionData.encabezado.FECMOV)}</p>
                            </Col>
                            <Col md={6}>
                                <p><strong>Cliente Proveedor:</strong> {rendicionData.encabezado.CLIPRO}</p>
                                <p><strong>Valor Entregado:</strong> {rendicionData.encabezado.VALENT?.toLocaleString()}</p>
                                <p><strong>Valor Rendición:</strong> {rendicionData.encabezado.VALREN?.toLocaleString()}</p>
                                <p><strong>Descripción:</strong> {rendicionData.encabezado.DESCRI}</p>
                            </Col>
                        </Row>

                        <h6>Detalles</h6>
                        {rendicionData.detalles && rendicionData.detalles.length > 0 ? (
                            <Table striped>
                                <thead>
                                    <tr>
                                        <th>CORFOL</th>
                                        <th>Fecha Mov</th>
                                        <th>Tipo Doc</th>
                                        <th>N° Doc</th>
                                        <th>Valor Total</th>
                                        <th>Descripción</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {rendicionData.detalles.map((detalle, index) => (
                                        <tr key={index}>
                                            <td>{detalle.CORFOL}</td>
                                            <td>{formatDate(detalle.FECMOV)}</td>
                                            <td>{detalle.TIPDOC}</td>
                                            <td>{detalle.NUMDOC}</td>
                                            <td>{detalle.VALTOT?.toLocaleString()}</td>
                                            <td>{detalle.DESCRI}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        ) : (
                            <p>No hay detalles disponibles.</p>
                        )}
                    </>
                ) : (
                    <div>No se encontraron datos.</div>
                )}
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggle}>Cerrar</Button>
            </ModalFooter>
        </Modal>
    );
};

export default ModalLeerRendicionFondos;